namespace $ {

	export function $shm_wordstat_region_tree() {
		return $mol_fetch.json(
			'/shm/wordstat/region/tree/_regions.json',
			{ cache: 'force-cache' },
		) as readonly $shm_wordstat_region_info[]
	}

}
